export const MIN_SCALING_FACTOR = 0.3;
export const MIN_ALLOW_SCALING_FACTOR = 1.8;
export const TRANSITION_ZOOM_DURATION = 500;
export const VIEWPORT_PADDING = 30